// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { price as priceUtil } from '@eti/utils';
import * as allProducts from '../products';
export const generateMuxProductKey = products => {
  var _products$sort$map$jo;
  return (_products$sort$map$jo = products.sort((a, b) => Number(a.id) - Number(b.id)).map(p => p.id).join('-')) !== null && _products$sort$map$jo !== void 0 ? _products$sort$map$jo : '';
};
export const getEmptyOptionId = identifierKey => `emptyOption-${identifierKey}`;
export const getPrice = sellSpecification => {
  if (!sellSpecification) {
    return 0;
  }
  if ('sellPriceTravelers' in sellSpecification) {
    var _sellSpecification$se;
    return (_sellSpecification$se = sellSpecification.sellPriceTravelers) === null || _sellSpecification$se === void 0 ? void 0 : _sellSpecification$se.reduce((accumulatedTotalPrice, currentTraveler) => {
      var _currentTraveler$pric;
      return accumulatedTotalPrice + ((currentTraveler === null || currentTraveler === void 0 || (_currentTraveler$pric = currentTraveler.price) === null || _currentTraveler$pric === void 0 || (_currentTraveler$pric = _currentTraveler$pric.price) === null || _currentTraveler$pric === void 0 ? void 0 : _currentTraveler$pric.value) || 0);
    }, 0);
  }
  if ('price' in sellSpecification) {
    var _sellSpecification$pr;
    return sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$pr = sellSpecification.price) === null || _sellSpecification$pr === void 0 || (_sellSpecification$pr = _sellSpecification$pr.price) === null || _sellSpecification$pr === void 0 ? void 0 : _sellSpecification$pr.value;
  }
  return 0;
};
export const getSelectionPerTravelerId = sellSpecification => {
  return sellSpecification && 'sellPriceTravelers' in sellSpecification ? sellSpecification.sellPriceTravelers.map(traveler => traveler === null || traveler === void 0 ? void 0 : traveler.travelerId).filter(Boolean) : null;
};
export const getCoverGeniusTranslations = (product, t, codeName, isInUKMarket, isInUSMarket) => {
  const productTitle = t(`${codeName}Title`);
  let productDescription = t(`${codeName}AbstractText`);
  let productReadMore = t(`${codeName}AdditionalInformation`);
  const ipidUrlText = 'coverGeniusIPIDPolicyLinkText';
  const termsUrlText = 'coverGeniusPolicyLinkText';
  const {
    ipid,
    termsUrl,
    disclaimer
  } = (product === null || product === void 0 ? void 0 : product.productSpecificTexts) || {};
  const ipidUrl = ipid === null || ipid === void 0 ? void 0 : ipid.url;
  if (!ipidUrl && !termsUrl && !disclaimer) {
    return {
      productTitle,
      productDescription,
      productReadMore
    };
  }
  const ipidPolicyHtml = `<a href=${ipidUrl} target="_blank">${t(ipidUrlText)}</a><br/>`;
  const termsUrlHtml = `<a href=${termsUrl} target="_blank">${t(termsUrlText)}</a><br/>`;
  const disclaimerHtml = `<br/><p> ${disclaimer} </p>`;
  const linksHtml = `${ipidPolicyHtml}${termsUrlHtml}`;
  const disclaimerInUS = isInUSMarket && disclaimerHtml || '';
  const disclaimerOutsideUs = !isInUSMarket && disclaimerHtml || '';
  const productReadMoreLinks = !isInUSMarket && !isInUKMarket ? linksHtml : '';
  const descriptionLinksForUkAndUs = isInUSMarket || isInUKMarket ? linksHtml : '';
  productDescription = `${productDescription}${disclaimerInUS}${descriptionLinksForUkAndUs}`;
  productReadMore = `${productReadMore}${productReadMoreLinks}${disclaimerOutsideUs}`;
  return {
    productTitle,
    productDescription,
    productReadMore
  };
};
export const productData = (product, numberOfTravelers) => {
  const {
    id: productId,
    configuration,
    sellSpecification
  } = product;
  const {
    showPricePerTraveler
  } = (configuration === null || configuration === void 0 ? void 0 : configuration.travelerDetails) || {};
  const priceRaw = getPrice(sellSpecification !== null && sellSpecification !== void 0 ? sellSpecification : null);
  const pricePerTravelerRaw = showPricePerTraveler ? priceUtil.getPriceDivided(priceRaw, numberOfTravelers) : null;
  return {
    pricePerTraveler: priceUtil.formatPrice(pricePerTravelerRaw),
    totalPrice: priceUtil.formatPrice(priceRaw),
    productId,
    showPricePerTraveler: Boolean(showPricePerTraveler)
  };
};
export const getNewFormValues = (selectedProductId, products) => products.map(product => {
  const field = Object.values(allProducts).find(allProduct => allProduct.id === Number(product.id));
  const fieldName = (field === null || field === void 0 ? void 0 : field.name) || '';
  const {
    sellSpecification
  } = product;
  const value = product.id === selectedProductId;
  const priceRaw = value ? getPrice(sellSpecification) : null;
  const travelerIds = getSelectionPerTravelerId(sellSpecification);
  const formValue = travelerIds ? {
    value: {
      priceRaw,
      value
    },
    travelerIds
  } : {
    value: {
      priceRaw,
      value
    }
  };
  return {
    fieldName,
    formValue
  };
});
//# sourceMappingURL=utils.js.map